"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // attribs of 1A
  NAME: 'name',
  LINKED_IN: 'linkedin_url',
  ADDRESS: 'address',
  DEGREE_MAJOR: 'degree_major',
  MINOR: 'minor',
  CONCENTRATION: 'concentration',
  GPA: 'gpa',
  SCHOLARSHIP: 'scholarship',
  HONORS: 'honors',
  STUDY_ABROAD: 'study_abroad',
  HIGH_SCHOOL_INFO: 'high_school_info',
  ENHANCED_EXP: 'enhanced_exp',
  COLLEGIATE_ATHLETICS: 'collegiate_athletics',
  // attribs of 1B
  TECHNICAL_SKILLS: 'technical_skills',
  LANGUAGE_SKILLS: 'language_skills',
  PERSONAL_INTERESTS: 'personal_interests',
  CERTIFICATIONS_LICENCES: 'certifications_licenses',
  // attribs of 1C
  PROFESSIONAL: 'professional',
  LEADERSHIP_AND_ACTIVITIES: 'leadership_and_activities',
  PROFESSIONAL_EXPERIENCES: 'professional_experiences',
  OTHER_EXPERIENCES: 'other_experiences',
  BULLETS_BUZZ: 'bullets_buzz',
  // attribs of PC
  WRITING_SAMPLES: 'writing_samples',
  COURSEWORK: 'coursework',
  INDUSTRIES: 'industries',
  JOB_FUNCTIONS: 'job_functions',
  CAREER_KEYWORDS: 'career_keywords',
  SEARCH_STATUS: 'search_status',
  PROFILE_PHOTO: 'profile_photo'
};
exports.default = _default;